import React, { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { ShoppingCart, X } from 'lucide-react';
import { useCart } from '../context/CartContext';

const MiniCart = () => {
  const { cartItems, getItemsCount, getSubtotal, removeFromCart } = useCart();
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();
  const { country } = useParams();

  const itemsCount = getItemsCount();
  const subtotal = getSubtotal();

  const handleViewCart = () => {
    setIsOpen(false);
    navigate(`/${country || 'br'}/cart`);
  };

  return (
    <div className="relative">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="relative p-2 hover:bg-aug-cream rounded-lg transition-colors"
        data-testid="mini-cart-button"
      >
        <ShoppingCart className="w-6 h-6 text-aug-gray-dark" />
        {itemsCount > 0 && (
          <span className="absolute -top-1 -right-1 w-5 h-5 bg-aug-green-success text-white text-xs font-bold rounded-full flex items-center justify-center">
            {itemsCount}
          </span>
        )}
      </button>

      {isOpen && (
        <>
          <div
            className="fixed inset-0 z-40"
            onClick={() => setIsOpen(false)}
          />

          <div className="absolute right-0 top-full mt-2 w-80 bg-white rounded-xl shadow-2xl z-50 max-h-96 overflow-hidden">
            <div className="flex items-center justify-between p-4 border-b border-aug-gray-light">
              <h3 className="font-semibold text-aug-gray-dark">
                Carrinho ({itemsCount})
              </h3>
              <button
                onClick={() => setIsOpen(false)}
                className="p-1 hover:bg-aug-cream rounded"
              >
                <X className="w-5 h-5" />
              </button>
            </div>

            {cartItems.length === 0 ? (
              <div className="p-8 text-center text-aug-gray-medium">
                Seu carrinho está vazio
              </div>
            ) : (
              <>
                <div className="max-h-60 overflow-y-auto p-4 space-y-3">
                  {cartItems.map((item) => (
                    <div key={item.id} className="flex gap-3">
                      <img
                        src={item.images?.[0]?.url || 'https://via.placeholder.com/100'}
                        alt={item.name}
                        className="w-16 h-16 object-cover rounded"
                      />
                      <div className="flex-1 min-w-0">
                        <h4 className="text-sm font-medium text-aug-gray-dark truncate">
                          {item.name}
                        </h4>
                        <p className="text-xs text-aug-gray-medium">
                          Qtd: {item.quantity}
                        </p>
                        <p className="text-sm font-semibold text-aug-green">
                          R$ {((item.sale_price || item.regular_price) * item.quantity).toFixed(2)}
                        </p>
                      </div>
                      <button
                        onClick={() => removeFromCart(item.id)}
                        className="text-aug-error hover:bg-red-50 p-1 rounded"
                      >
                        <X className="w-4 h-4" />
                      </button>
                    </div>
                  ))}
                </div>

                <div className="p-4 border-t border-aug-gray-light space-y-3">
                  <div className="flex justify-between items-center">
                    <span className="font-semibold text-aug-gray-dark">Subtotal:</span>
                    <span className="text-xl font-bold text-aug-green">
                      R$ {subtotal.toFixed(2)}
                    </span>
                  </div>
                  <button
                    onClick={handleViewCart}
                    className="w-full bg-aug-blue hover:bg-aug-blue-dark text-white py-3 rounded-lg font-semibold transition-colors"
                  >
                    Ver Carrinho
                  </button>
                </div>
              </>
            )}
          </div>
        </>
      )}
    </div>
  );
};

export default MiniCart;